<template>
	<Card :title="trans('enrollments.packs.title')" :subtitle="trans('enrollments.packs.subtitle')">
		<LabeledObject v-if="selectionStage">
			<template #label>{{ trans('enrollments.packs.selections.deadline') }}</template>
			<p>{{ dayjs(selectionStage.ends_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<div class="flex items-end justify-start gap-2">
			<Link v-if="allowedToAddPacks" :as="SecondaryButton" :color="Color.Green" :href="route('events.enrollments.packs.create', enrollment.id)">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('enrollments.packs.add') }}
			</Link>
		</div>
		<List>
			<template v-for="pack in selectedPacks">
				<ListItem
					:title="pack.name"
					:subtitle="trans('events.packs.selected_count', {selected: `${selectedActivitiesByPack[pack.id] ?? 0}`, total: `${totalActivitiesByPack[pack.id]}`})"
				>
					<template #accessory>
						<Link v-if="allowedToSelectActivities && totalActivitiesByPack[pack.id] > 0 && selectionStagePackIds.includes(pack.id)" :as="SecondaryButton" :color="Color.Blue" :href="route('events.enrollments.packs.show', [enrollment.id, pack.id])">
							<i class="fa-solid fa-list-check mr-2"/>
							{{ trans('general.edit') }}
						</Link>
						<p v-else class="text-gray-400 dark:text-gray-600">{{ trans('enrollments.packs.selections.closed') }}</p>
					</template>
				</ListItem>
			</template>
		</List>
	</Card>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/Cards/Card.vue'
import List from '@/Components/Lists/List.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import ListItem from '@/Components/Lists/ListItem.vue'
import LabeledObject from '@/Components/LabeledObject.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'
import {type SelectionStage} from '@/Types/Events/Stages/SelectionStage'

const props = defineProps<{
	enrollment:Enrollment,
	selectedPacks:Array<Pack>,
	allowedToAddPacks:boolean,
	selectionStage:SelectionStage,
	allowedToSelectActivities:boolean,
	selectionStagePackIds:Array<number>,
	totalActivitiesByPack:Array<number>,
	selectedActivitiesByPack:Array<number>,
}>()

const enrollment:Ref<Enrollment> = ref(props.enrollment)
const selectedPacks:Ref<Array<Pack>> = ref(props.selectedPacks)
const allowedToAddPacks:Ref<boolean> = ref(props.allowedToAddPacks)
const selectionStage:Ref<SelectionStage> = ref(props.selectionStage)
const selectionStagePackIds:Ref<Array<number>> = ref(props.selectionStagePackIds)
const totalActivitiesByPack:Ref<Array<number>> = ref(props.totalActivitiesByPack)
const allowedToSelectActivities:Ref<boolean> = ref(props.allowedToSelectActivities)
const selectedActivitiesByPack:Ref<Array<number>> = ref(props.selectedActivitiesByPack)
</script>